import React from 'react';

import useDocumentTheme from 'hooks/theme/useDocumentTheme';

import headerLogo from 'assets/header-logo.png';
import headerLogoDark from 'assets/header-logo-dark.png';

/**
 * Logo horizontal da Ampere. No escuro usa a variante com o "AMPERE" claro
 * (`header-logo-dark.png`, gerada a partir do original — o azul-marinho some no fundo noite).
 */
export default function BrandLogo({ alt, className }: { alt: string; className?: string }) {
  const theme = useDocumentTheme();
  return <img src={theme === 'dark' ? headerLogoDark : headerLogo} alt={alt} className={className} />;
}
